import axios from 'axios';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import {
  GET_ENQUIRY_MESSAGES,
  SEND_MESSAGE_TO_LEAD,
  get_token,
  get_headers,
  get_project_id
} from '@/utils/constants/constants';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';

export default {
  name: 'EnquiryChat',
  components:{
    AICampusFooter,
    NavigationBackButton
  },
  data: () => ({
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    lead_messages: {},
    lead_message: '',
    pollInterval: null,
    lead_id: null,
    user_scrolled_up: false,
    selected_file: null,
    viewer_open: false,
    viewer_url:  '',
    viewer_name: ''

  }),
  mounted() {
    this.lead_id = sessionStorage.getItem('lead_id');
    this.fetch_lead_messages();
    this.pollInterval = setInterval(this.fetch_lead_messages, 1000);
    this.$refs.scrollContainer?.addEventListener('scroll', this.handle_user_scroll);
  },
  beforeUnmount() {
    clearInterval(this.pollInterval);
    this.$refs.scrollContainer?.removeEventListener('scroll', this.handle_user_scroll);
  },
  methods: {
    is_image(name) {
      return /\.(png|jpe?g|gif|webp|bmp)$/i.test(name || '');
    },

    open_attachment(msg) {
      this.viewer_url  = msg.attachment_url;
      this.viewer_name = msg.attachment_name;
      this.viewer_open = true;
    },

    close_viewer() {
      this.viewer_open = false;
      this.viewer_url  = '';
      this.viewer_name = '';
    },

    handle_file_change(e) {
    this.selected_file = e.target.files[0] || null;
    },
    clear_file() {
      this.selected_file = null;
      this.$refs.file_input.value = "";
    },

    fetch_lead_messages() {
      if (!this.lead_id) {
        return;
      }

      axios.get(GET_ENQUIRY_MESSAGES, {
        params: { lead_id: this.lead_id },
        headers: this.headers
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.lead_messages = response.data.data;
          this.scrollToBottom();
        }
      })
      .catch(error => {
        console.error('Failed to fetch messages', error);
      });
    },

    send_lead_message() {
      if (!this.lead_message.trim() && !this.selected_file || !this.lead_id) return;

      const form_data = new FormData();
      form_data.append('lead_id', this.lead_id);
      form_data.append('is_superuser', false);
      if (this.lead_message.trim()) {
        form_data.append('message', this.lead_message.trim());
      }
      if (this.selected_file) {
        form_data.append('attachment', this.selected_file);
      }

      axios.post(SEND_MESSAGE_TO_LEAD, form_data, {
        headers: {...this.headers, 'Content-Type': 'multipart/form-data'}
      })
      .then(response => {
        if (response.data.status === 'success') {
          this.lead_message = '';
          this.clear_file();
          this.fetch_lead_messages();
        } else {
          console.warn('Failed to send message:', response.data.message);
        }
      })
      .catch(error => {
        console.error('Failed to send message', error);
      });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        if (container && !this.user_scrolled_up) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    handle_user_scroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;
      const atBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
      this.user_scrolled_up = !atBottom;
    },
  }
};